export default {
  title: "",
  subtitle: "PSE banks",
  path: "pse_banks",
  paragraphs: 
    [
      "This endpoint is used to get the list of supported bank institutions for PSE in Colombia. You’ll need to request it once a week, as it is updated on this frequency, and you’ll use the results to populate a dropdown list in the same order they are returned. "
    ],
  request: {
    method: "GET", 
    endpoint: "/bank_accounts/pse",
    responses: {
      "data": [
        {
          "name": "A continuación seleccione su banco",
          "code": "0"
        },
        {
          "name": "ALIANZA FIDUCIARIA",
          "code": "1815"
        },
        {
          "name": "BAN100",
          "code": "1558"
        }
      ]
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPseBanks.js